import React from 'react';
import { SegmentedControl } from '@/components/ui';

export type ScheduleTimelineScale = 'today' | 'weeks' | 'months';

interface ScheduleTimelineScaleSwitcherProps {
  value: ScheduleTimelineScale;
  onChange: (value: ScheduleTimelineScale) => void;
  'aria-label'?: string;
}

const OPTIONS: Array<{ value: ScheduleTimelineScale; label: string }> = [
  { value: 'today', label: 'Today' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
];

/** Timeline zoom, shown beside the chart key at the top of the chart (W-M13). */
const ScheduleTimelineScaleSwitcher: React.FC<ScheduleTimelineScaleSwitcherProps> = ({
  value,
  onChange,
  'aria-label': ariaLabel = 'Schedule timeline scale',
}) => <SegmentedControl aria-label={ariaLabel} value={value} onChange={onChange} options={OPTIONS} />;

export default ScheduleTimelineScaleSwitcher;
